import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './finished.content.json';

/**
 * @module FinishedModule
 * @ngdoc component
 * @name FinishedComponent
 */
@Component({
    selector: 'tokens-browser-finished',
    templateUrl: 'finished.component.html',
    standalone: false
})
export class FinishedComponent implements OnInit {
    @Output()
    public login: EventEmitter<string> = new EventEmitter();

    public constructor(private readonly contentService: ApContentService) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public onLogin(): void {
        this.login.emit();
    }

    public getIllustrationName(): string {
        return this.contentService.get('tokens.browser.finished.illustration');
    }
}
